import React from "react";
import useRickMortyAPI from "../hooks/useRickMortyAPI";

import { MainContainer } from "./MainContainer";

interface IMode {
  mode: string;
}

export const RickMortyApp: React.FC<IMode> = ({ mode }) => {
  const { characters, loading, filter, handleChange, handleNext } =
    useRickMortyAPI(mode);

  return (
    <MainContainer
      mode={mode}
      characters={characters}
      loading={loading}
      filter={filter}
      handleChange={handleChange}
      handleNext={handleNext}
    />
  );
};
